<div class="privacy-policy">
  <div class="container">
    <div class="row mt mt-3">
      <div class="col-12 text-center h3">Privacy Policy</div>
      <div class="col-12 text-center text-secondary">
        Effective Date: May 04, 2026 &middot; Last Updated: May 04, 2026
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        Universal Processing LLC ("uOrder," "we," "us," or "our") operates the
        website <a href="https://www.uorder.io">https://www.uorder.io</a> and
        the uOrder online food-ordering platform (collectively, the
        "Services"). This Privacy Policy explains how we collect, use,
        disclose, and safeguard information about visitors to our website and
        customers who place orders through the Services.
      </div>

      <div class="col-12 h6 mt-4">1. Information We Collect</div>
      <div class="col-12">
        We collect the following categories of personal information:
        <ul class="ps-4 mt-2">
          <li>
            <b>Identifiers</b> &mdash; name, email address, mobile phone
            number, postal address, account credentials, IP address, device
            identifiers.
          </li>
          <li>
            <b>Order and transaction information</b> &mdash; items ordered,
            order total, payment-method tokens (we do not store full card
            numbers; payment is processed by our PCI-DSS compliant payment
            processor), receipts.
          </li>
          <li>
            <b>SMS consent records</b> &mdash; for customers who opt in at
            checkout to receive a one-time order- or payment-related SMS, we
            record the mobile number entered at checkout, the timestamp, the
            consent disclosure text shown, the order ID, and the IP address
            and user agent of the submitting device.
          </li>
          <li>
            <b>Communications</b> &mdash; content of messages we send to or
            receive from you (including SMS and email) and customer-support
            inquiries.
          </li>
          <li>
            <b>Usage and device data</b> &mdash; log files, browser type, pages
            viewed, timestamps, cookies and similar tracking technologies.
          </li>
          <li>
            <b>Location information</b> &mdash; coarse location derived from IP
            address.
          </li>
        </ul>
        We collect this information when you place an order through the
        Services or, at checkout, opt in to receive an order- or payment-
        related SMS.
      </div>

      <div class="col-12 h6 mt-4">2. How We Use Information</div>
      <div class="col-12">
        We use personal information to: provide, operate, and maintain the
        Services, including delivering a one-time order- or payment-related
        SMS to customers who have opted in at checkout; route your order to
        the correct restaurant for fulfillment; process payments and prevent
        fraud; respond to inquiries and provide customer support; improve and
        personalize the Services; send service-related notices; and comply
        with legal obligations and enforce our agreements.
      </div>

      <div class="col-12 h6 mt-4">
        3. SMS / Mobile Messaging &mdash; Opt-In, Use and Disclosure
      </div>
      <div class="col-12">
        The uOrder SMS program sends a single transactional, one-time SMS to
        customers who have explicitly opted in at checkout. The SMS contains
        either information about the customer's order (such as an order
        confirmation) or a payment link associated with the order. We do not
        send SMS marketing messages.
      </div>

      <div class="col-12 mt-3"><b>Opt-in.</b></div>
      <div class="col-12 mt-1">
        At checkout, you may optionally opt in to receive this SMS by ticking
        the SMS consent checkbox shown adjacent to the phone-number field on
        the checkout page. The checkbox is unchecked by default. The
        disclosure text displayed adjacent to the checkbox reads: "Yes, send
        me a one-time order- or payment-related SMS at this number. Msg &amp;
        data rates may apply. Reply STOP to opt out, HELP for help. By
        checking, you agree to our SMS Terms and Privacy Policy."
      </div>
      <div class="col-12 mt-2">
        When you tick the box and submit the order, we send ONE transactional
        SMS confirming that order. We do not send any further SMS to you in
        connection with that consent, do not add the number to any contact or
        marketing list, and do not use the number for any future messaging.
        The number is not added to your account profile. We retain the mobile
        number, the timestamp, the disclosure text shown, the order ID, and
        the IP address and user agent of the submitting device, solely as a
        consent and order-evidence record required by applicable law and our
        SMS aggregator.
      </div>

      <div class="col-12 mt-3"><b>Sharing and opt-out.</b></div>
      <div class="col-12 mt-1">
        No mobile information will be shared with third parties or affiliates
        for marketing or promotional purposes. Information sharing with
        subcontractors that help us deliver the SMS Services (specifically our
        SMS aggregator and telecommunications provider, Twilio Inc.) is
        permitted solely for the purpose of transmitting the messages
        requested. All other categories of personal information described in
        this Privacy Policy exclude text-messaging originator opt-in data and
        consent; this information will not be shared with any third parties.
      </div>
      <div class="col-12 mt-2">
        You may opt out of SMS at any time by replying STOP to any message you
        receive from us. You will receive only a single one-shot SMS per order
        placed with consent; replying STOP suppresses any future order- or
        payment-related SMS to that number. For help, reply HELP or contact us
        at the information in Section 11. Message and data rates may apply.
        Message frequency is one message per order placed with consent. See
        our SMS Terms of Service at
        <a href="https://www.uorder.io/sms-terms">https://www.uorder.io/sms-terms</a>
        for additional details.
      </div>

      <div class="col-12 h6 mt-4">4. How We Share Information</div>
      <div class="col-12">
        We do not sell, rent, or trade your personal information. We share
        personal information only as follows: service providers acting on our
        behalf (payment processors, SMS aggregator Twilio, cloud-hosting
        providers, analytics, IT vendors) bound by confidentiality and
        permitted to use data only to perform services for us; the restaurant
        fulfilling your order, with respect to that order; legal compliance
        and protection of rights when required by law, subpoena, court order,
        or to protect the safety, rights, or property of uOrder, our users,
        or others; business transfers in connection with a merger,
        acquisition, financing, or sale of assets, subject to confidentiality;
        and with your consent for any other disclosure not described above.
      </div>
      <div class="col-12 mt-2">
        In all cases, the foregoing exclusions apply: text-messaging
        originator opt-in data and consent will not be shared with any third
        parties for any purpose other than delivering the messages you have
        requested.
      </div>

      <div class="col-12 h6 mt-4">5. Cookies and Tracking Technologies</div>
      <div class="col-12">
        Our website uses cookies, pixels, and similar technologies to operate
        the site, remember preferences, measure traffic, and support order
        workflows. You can control cookies through your browser settings.
      </div>

      <div class="col-12 h6 mt-4">6. Data Retention</div>
      <div class="col-12">
        We retain personal information for as long as necessary to provide the
        Services, comply with legal and tax obligations, resolve disputes, and
        enforce our agreements. SMS consent records are retained for the
        period required by applicable law or carrier requirement (generally
        not less than four years). Mobile numbers collected for the one-time
        order- or payment-related SMS are retained only on the order/consent
        record and are not added to your account profile or any contact list.
      </div>

      <div class="col-12 h6 mt-4">7. Data Security</div>
      <div class="col-12">
        We use commercially reasonable administrative, technical, and physical
        safeguards &mdash; including TLS encryption in transit, encryption at
        rest for sensitive fields, access controls, and vendor due diligence
        &mdash; to protect personal information. No method of transmission or
        storage is 100% secure, and we cannot guarantee absolute security.
      </div>

      <div class="col-12 h6 mt-4">8. Your Rights</div>
      <div class="col-12">
        Depending on your jurisdiction, you may have the right to access,
        correct, or request deletion of your personal information; opt out of
        certain uses or disclosures; withdraw consent (including by replying
        STOP to SMS messages); and lodge a complaint with a supervisory
        authority. California residents have additional rights under CCPA/CPRA.
        We do not sell or share personal information for cross-context
        behavioral advertising. To exercise any right, contact us using
        Section 11.
      </div>

      <div class="col-12 h6 mt-4">9. Children's Privacy</div>
      <div class="col-12">
        The Services are not directed to children under 13, and we do not
        knowingly collect personal information from them.
      </div>

      <div class="col-12 h6 mt-4">10. Changes to This Policy</div>
      <div class="col-12">
        We may update this Privacy Policy from time to time. The "Last Updated"
        date at the top reflects the latest revision. Continued use of the
        Services after the changes take effect constitutes acceptance.
      </div>

      <div class="col-12 h6 mt-4">11. Contact Us</div>
      <div class="col-12">
        <ul class="ps-4">
          <li>Universal Processing LLC</li>
          <li>215 W 40th St Floor 8, New York, NY 10018</li>
          <li>Email: <a href="mailto:privacy&#64;uorder.io">privacy&#64;uorder.io</a></li>
          <li>Phone: 888-885-8840</li>
        </ul>
      </div>
    </div>
  </div>
</div>
